import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React, { useState} from 'react';
import { constants } from '../constants';
import Preview, { previewModalSize } from '../pages/MyM906_Preview/Preview';
import { MyMImage } from '../ui-elements/MyMImage';
import { MyMLabel } from '../ui-elements/MyMLabel';
import { MyMModal } from '../ui-elements/MyMModal';
import { utility } from '../utility';
import BoxFileRequestMenu from './BoxFileRequestMenu';
import ContentsSlider from './ContentsSlider';
import { mediaQuery, useMediaQuery } from '../hooks/useMediaQuery';

/** MyMine Version2.0 リファクタ
 * MetadataFilesSlider
 */
const MetadataFilesSlider = (
  {
    controlSettings,
    screenId,
    selectedSlideMetadataList,
    setSelectedSlideMetadataList,
    callbackFavorite,
    metadataId,
    fileList,
    setIsLoading,
    // 2025.3.5 MyMine Version2.1対応 Add Start
    canShareContents,
    // 2025.3.5 MyMine Version2.1対応 Add End
  }) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewFileId, setPreviewFileId] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  // 2024.9.16 MyMine Version2.0対応 Add Start

  const isPcOriginal = useMediaQuery(mediaQuery.pc);
  const isWideScreen = useMediaQuery('(min-width:1025px)');
  const isPc = isPcOriginal && isWideScreen;

  const slideToShow = isPc ? 2 : 1;
  const xsGrid1 = isPc ? 5 : 12;
  const xsGrid2 = isPc ? 7 : 12;
  const boxFileContentsHeight = isPc ? 250 : 300;
  const boxFileContentsWidth = isPc ? '100%' : '90%';
  const maxWidth = isPc ? '570px' : '320px';
  const boxWidth = isPc ? 'auto' : '320px';

  // 2024.9.16 MyMine Version2.0対応 Add End

  /**
   * 画像クリック処理(プレビュー表示)
   * @param {any} e
   * @param {any} fileId
   */
  const onClickPreview = (e, fileId) => {
    setPreviewFileId(fileId);
    setIsModalOpen(true);
  }

  /**
   * ファイルスライド処理
   * @param {any} slideMetadataId
   * @param {any} slideCount
   */
  const onChangeSlide = (slideMetadataId, slideCount) => {
    selectedSlideMetadataList[slideMetadataId] = slideCount;
    setSelectedSlideMetadataList(selectedSlideMetadataList)
  }


  return (
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    <Box sx={{ width: boxWidth, margin: '0 auto' }}>
      <ContentsSlider
        initialSlide={selectedSlideMetadataList[metadataId] || 0}
        onChangeSlide={(slideCount) => onChangeSlide(metadataId, slideCount)}
        contentsCount={fileList.length}
        // 2024.9.16 MyMine Version2.0対応 Add Start
        slidesToShow={slideToShow}
        // 2024.9.16 MyMine Version2.0対応 Add End
      >
        {fileList.map((boxFile) =>
          <Grid key={boxFile.FileId} container className='d-flex justify-content-center' sx={{ minHeight: boxFileContentsHeight, maxWidth: maxWidth }}>
            <Grid item xs={xsGrid1} className='text-center' >
              <Box
                className='d-flex align-items-center justify-content-center'
                sx={{
                  height: boxFileContentsHeight,
                  '> img':
                  {
                    maxWidth: boxFileContentsWidth,
                    ':hover': { cursor: 'pointer' }
                  }
                }}
              >
                {
                  boxFile.ThumbnailFilePath
                    ? <img
                      src={`api/page/file?fileName=${boxFile.ThumbnailFilePath}`}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = `${process.env.PUBLIC_URL}/${screenId}/${controlSettings.ImageList.imgCategoryThumbnail}`;
                      }}
                      className='d-inline'
                      alt=''
                      onClick={(e) => { onClickPreview(e, boxFile.FileId) }} />
                    : <MyMImage className='d-inline' screenId={screenId} filePath={controlSettings.ImageList.imgCategoryThumbnail} onClick={(e) => { onClickPreview(e, boxFile.FileId) }} />
                }
              </Box>
            </Grid>
            <Grid item xs={xsGrid2} className='d-flex justify-content-center flex-column px-2 py-2'>
              <Grid container columns={12}>
                <Grid item xs={4.5}>
                  <MyMLabel component='span'>{controlSettings.LabelList.lblCategoryDocumentName}</MyMLabel>
                </Grid>
                <Grid item xs={7.5}>
                  <MyMLabel component='span' className="fw-bold">{boxFile.NameDisp ?? boxFile.NameOrigin ?? ''}</MyMLabel>
                </Grid>
                <Grid item xs={4.5}>
                  <MyMLabel component='span'>{controlSettings.LabelList.lblCategoryDocumentType}</MyMLabel>
                </Grid>
                <Grid item xs={7.5}>
                  <MyMLabel component='span'>{boxFile.Description ?? ''}</MyMLabel>
                </Grid>
                <Grid item xs={4.5}>
                  <MyMLabel component='span'>{controlSettings.LabelList.lblCategoryFileSize}</MyMLabel>
                </Grid>
                <Grid item xs={7.5}>
                  <MyMLabel component='span'>{utility.convertFileSize(boxFile.FileSize, constants.FileSize.MB)?.toFixed(2) ?? ''}</MyMLabel>
                  <MyMLabel component='span'>{controlSettings.LabelList.lblCategoryFileSizeUnit}</MyMLabel>

                </Grid>
                <Grid item xs={4.5}>
                  <MyMLabel component='span'>{controlSettings.LabelList.lblCategoryFileType}</MyMLabel>
                </Grid>
                <Grid item xs={7.5}>
                  <MyMLabel component='span'>{boxFile.Extension ?? ''}</MyMLabel>

                </Grid>
                <Grid item xs={4.5}>
                  <MyMLabel component='span'>{controlSettings.LabelList.lblCategoryUploadDate}</MyMLabel>
                </Grid>
                <Grid item xs={7.5}>
                  <MyMLabel component='span'>{boxFile.FormatUploadDate ?? ''}</MyMLabel>
                </Grid>
              </Grid>
              <Box className='pt-1 d-flex'>
                <BoxFileRequestMenu
                  screenId={screenId}
                  fileId={boxFile.FileId}
                  setIsLoading={setIsLoading}
                  isFavorite={boxFile.IsFavorite}
                  callbackFavorite={callbackFavorite}
                  // 2025.3.5 MyMine Version2.1対応 Add Start
                  canShareContents={canShareContents}
                  metadataId={metadataId}
                  // 2025.3.5 MyMine Version2.1対応 Add End
                />
              </Box>
            </Grid>
          </Grid>
        )}
      </ContentsSlider>
      {isModalOpen && <MyMModal
        open={isModalOpen}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>}
    </Box>
    // 2024.9.16 MyMine Version2.0対応 Modify End
  );
}
export default MetadataFilesSlider;